module.exports = __webpack_public_path__ + "static/giant_ankheg-mtg_clb-129e5510a007aefb2fb1cf068abdc846.webp";